import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { InspectionFireExtinguishers } from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-fire-extinguishers',
  templateUrl: './fire-extinguishers.component.html',
  styleUrls: ['./fire-extinguishers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FireExtinguishersComponent {
  @Input() data: InspectionFireExtinguishers;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  onDataChange(): void {
    this.dataChange.emit();
  }
}
